import { useLocation, useParams } from "react-router";
import { EnumOwnerType, Owner } from "../../gql/generated.ts";
import { useMemo } from "react";
import { TNB_INTERNAL_OWNER_ID } from "shared/constants/internalIds";

type LoggedInAs = Owner | null;

/**
 * Returns the type of user we're logged in as.
 * Derived synchronously from the URL so that the value is correct on the
 * same render cycle as a navigation (no one-frame delay).
 */
export const useLoggedInAs = (): LoggedInAs => {
  const location = useLocation();
  const params = useParams();

  return useMemo(() => {
    const pathname = location.pathname;

    if (pathname.startsWith("/app/organization") && params.organizationId) {
      return {
        type: EnumOwnerType.Organization,
        entityId: params.organizationId,
      };
    }
    if (pathname.startsWith("/app/operator") && params.operatorEntityId) {
      return {
        type: EnumOwnerType.Operator,
        entityId: params.operatorEntityId,
      };
    }
    if (pathname.startsWith("/app/storefront") && params.storefrontId) {
      return {
        type: EnumOwnerType.Storefront,
        entityId: params.storefrontId,
      };
    }
    if (pathname.startsWith("/app/admin")) {
      return {
        type: EnumOwnerType.TnbInternal,
        entityId: TNB_INTERNAL_OWNER_ID,
      };
    }
    return null;
  }, [location.pathname, params.organizationId, params.operatorEntityId, params.storefrontId]);
};
